import React from "react";
import { PlusOutlined } from "@ant-design/icons";

import colors from "constants/palette";
import Button from "components/buttons/Button";
import ManageProductModal from "components/Modals/ManageProductModal";

/**
 *
 * @param { Function} oldData for product modal
 * @param { Function} reload for product modal
 * @param { Function} setVisible for product modal
 * @param { Object} data for product modal
 * @param { Object } buttonStyle
 * @returns button with modal
 */

export default function App(props) {
  const { setVisible, buttonStyle, oldData, children } = props;

  const showModal = () => {
    setVisible(true);
  };

  return (
    <>
      <Button
        shape="round"
        color={colors.blue}
        onClick={showModal}
        style={buttonStyle && buttonStyle}
      >
        {children ? (
          children
        ) : (
          <>
            {oldData ? (
              "به روز رسانی"
            ) : (
              <span>
                <PlusOutlined style={{ marginLeft: 8 }} />
                اضافه کردن کالا
              </span>
            )}
          </>
        )}
      </Button>
      <ManageProductModal {...props} />
    </>
  );
}
